<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px" v-if="formVisible">
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
            <div v-show="!nextStep">
              <div class="title-box"><span class="txt1">课程基础信息</span></div>
              <el-form-item label="课程类型：" prop="type" class="width100">
                <el-radio-group v-model="form.type">
                  <el-radio :label="1">图文</el-radio>
                  <el-radio :label="2">视频</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="课程名称：" prop="name">
                <el-input v-model="form.name" placeholder="请输入课程名称" />
              </el-form-item>
              
              <el-form-item label="APP展示：" prop="appDisplay">
                <el-checkbox-group v-model="form.appDisplay">
                  <el-checkbox :label="1">课程</el-checkbox>
                  <el-checkbox :label="2" v-if="form.type === 2">业务物料(只有视频课)</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              
              <el-form-item label="课程分类：" prop="courseClassificationList" v-if="sourceType === 2 && form.appDisplay && form.appDisplay.includes(1)">
                <el-cascader v-model="form.courseClassificationList" :props="categorizepProps" :options="courseClassOptions" :show-all-levels="false" multiple clearable></el-cascader>
              </el-form-item>
              <el-form-item label="福利类型：" prop="welfareId " v-if="sourceType === 1">
                <el-select v-model="form.welfareId " placeholder="请选择" clearable size="small">
                  <el-option v-for="(item,index) in welfareOptions" :key="index" :label="item.name" :value="item.id"></el-option>

                </el-select>
              </el-form-item>
              <el-form-item label="封面图：" prop="coverImage">
                <div class="flexs">
                  <imageUpload v-model="form.coverImage" width="32" height="32" />
                  <span class="hint hint1">限制上传1张<br />建议尺寸196x248像素以上</span>
                </div>
              </el-form-item>
              <el-form-item label="讲师：" prop="lecturerId" v-if="form.type === 2">
                <el-select v-model="form.lecturerId" placeholder="请选择" clearable size="small">
                  <el-option v-for="(item,index) in lecturerOptions" :key="index" :label="item.realName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="播放/浏览量：" prop="playNum">
                <el-input v-model="form.playNum" placeholder="请输入播放/浏览量" />
              </el-form-item>
              <el-form-item label="点赞量：" prop="likeNum">
                <el-input v-model="form.likeNum" placeholder="请输入点赞量" />
              </el-form-item>
              <el-form-item label="收藏量：" prop="collectNum">
                <el-input v-model="form.collectNum" placeholder="请输入收藏量" />
              </el-form-item>
              <el-form-item label="转发量：" prop="forwardNum">
                <el-input v-model="form.forwardNum" placeholder="请输入转发量" />
              </el-form-item>
              <el-form-item label="学分奖励：" prop="creditRewards" v-if="sourceType === 2">
                <el-input v-model="form.creditRewards" placeholder="请输入学分奖励" />
              </el-form-item>
              <el-form-item label="页面排序：" prop="orderNo">
                <el-input v-model="form.orderNo" placeholder="请输入" />
              </el-form-item>
              <div class="title-box"><span class="txt1">课程配置</span></div>
             
              <template v-if="!form.id && form.type === 2">
                <el-form-item label="上传课程：" required class="width100">
                  <upload-courses-vue :form="form" />
                </el-form-item>
              </template>
              <el-form-item label="课程介绍：" class="width100" v-if="form.type === 2">
                <editor v-model="form.introduce" :min-height="240" :height="240" :uploadUrl="uploadUrl" />
              </el-form-item>
              <el-form-item label="课程内容：" class="width100" v-if="form.type === 1">
                <editor v-model="form.content" :min-height="240" :height="240" :uploadUrl="uploadUrl" />
              </el-form-item>
              <template v-if="!form.id && form.type === 2">
                <div class="title-box"><span class="txt1">课件</span></div>
                <el-form-item label="课件：" class="width100">
                  <fileUpload v-model="form.wareList" hintText="支持上传格式PPT，PPTX，PDF" limit="10" isWatermark="1" limitType=".ppt,.pptx,.pdf" />
                </el-form-item>
                <div class="title-box"><span class="txt1">修复方案</span></div>
                <repair-plan-vue :form="form" />
              </template>
            </div>
            <div v-show="sourceType === 2 && nextStep === 1 && !form.id">
              <div class="title-box"><span class="txt1">考试配置</span></div>
              <exam-vue :form="form" />
              <div class="title-box"><span class="txt1">学习权限</span></div>
              <jurisdiction-vue :form="form" :rowItem="this.form" />
            </div>
            <el-form-item label="状态：" prop="state" class="width100">
              <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="formVisible = false">取消</el-button>
            <el-button type="primary" v-if="sourceType === 2 && nextStep && !form.id" @click="nextStep = 0">上一步</el-button>
            <el-button type="primary" @click="doCreate()">{{sourceType === 2 && !nextStep && !form.id?'下一步':'确认'}}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import courseSubjectApi from '@/api/course/courseSubject'
import sysGoodsApi from '@/api/goods/sysGoods'
import FileUpload from "@/components/FileUpload"
import ImageUpload from "@/components/ImageUpload";
import Editor from "@/components/Editor";
import jurisdictionVue from './common/jurisdiction.vue'
import uploadCoursesVue from './uploadCourses.vue';
import repairPlanVue from './common/repairPlan.vue';
import examVue from './common/exam.vue';
function initFormBean() {
  const formBean = {
    // id: 0,
    name: null,
    appDisplay: [],
    courseClassificationList: [],
    achievementScore: null,
    coverImage: null,
    chapterNum: 0,
    lecturerId: null,
    playNum: null,
    likeNum: null,
    collectNum: null,
    forwardNum: null,
    creditRewards: null,
    content: null,
    examCredits: null,
    examDuration: null,
    examNum: null,
    examOrder: null,
    feeAmount: null,
    freeWatchNum: null,
    examRules: null,
    introduce: null,
    isExam: 0,
    isLookSolution: 0,
    isRecommend: 0,
    orderNo: null,
    topicClassificationId: null,
    wareList: [],
    lookCredits: null,
    state: 0,
    type: 1,
    authData: [{ authType: 1 }, { authType: 2 }, { authType: 3 }],
    videoData: [{ duration: '', chaptersNum: '', name: '', coverImage: '', videoUrl: [], state: 1 }],
    repairPlanData: [{ name: '', coverImage: '', introduce: '', contentDetails: '', state: 1 }]
  }
  return formBean
}

export default {
  props: ['courseClassOptions', 'lecturerOptions', 'sourceType', 'welfareOptions'],
  components: {
    Editor, ImageUpload, FileUpload, jurisdictionVue,
    uploadCoursesVue, repairPlanVue, examVue
  },
  data() {
    return {
      nextStep: 0,
      categorizepProps: {
        label: 'typeName',
        value: 'id',
        children: 'classificationChildList',
        multiple: true
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
        appDisplay: [{ required: true, message: '请选择APP展示', trigger: 'change' }],
        courseClassificationList: [{ required: true, message: '请选择课程分类', trigger: 'change' }],
        welfareId: [{ required: true, message: '请选择福利类型', trigger: 'change' }],
        coverImage: [{ required: true, message: '请上传封面图', trigger: 'change' }],
        lecturerId: [{ required: true, message: '请选择讲师', trigger: 'change' }],
        creditRewards: [{ required: true, message: '请输入学分奖励', trigger: 'blur' }],
        type: [{ required: true, message: '请选择课程类型', trigger: 'change' }],
        content: [{ required: true, message: '请输入课程内容', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
        // isExam: [{ required: true, message: '请选择是否考试', trigger: 'change' }],
        topicClassificationId: [{ required: true, message: '请选择试卷题目', trigger: 'change' }],
        achievementScore: [{ required: true, message: '请输入考试达标分数', trigger: 'blur' }],
        examCredits: [{ required: true, message: '请输入考试完成后获得的学分', trigger: 'blur' }],
        examNum: [{ required: true, message: '请输入考试题数', trigger: 'blur' }],
        examSingleScore: [{ required: true, message: '请输入每道题得分', trigger: 'blur' },
        { pattern: /^\d+(\.\d{1,2})?$/, message: '必须为数字值', trigger: 'blur' }],
        examRules: [{ required: true, message: '请选择考试规则', trigger: 'change' }],
        isLookSolution: [{ required: true, message: '请选择是否能看答案', trigger: 'change' }],
        playNum: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        likeNum: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        collectNum: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        forwardNum: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        orderNo: [{ required: true, message: '请输入页面排序', trigger: 'change' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
      }
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
  },
  watch: {
    'form.type'(newVal) {
      // 当切换到图文类型时，移除业务物料选项
      if (newVal === 1 && this.form.appDisplay && this.form.appDisplay.includes(2)) {
        this.form.appDisplay = this.form.appDisplay.filter(item => item !== 2)
      }
    }
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.nextStep = 0
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      courseSubjectApi.fetchById(row.id).then(({ data }) => {
        this.form = data;
        // 确保appDisplay始终是数组
        if (!this.form.appDisplay || !Array.isArray(this.form.appDisplay)) {
          this.$set(this.form, 'appDisplay', []);
        }
        this.calcEditData()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    clacArrObj(str) {
      if (!str) return []
      // let arr = str.split(',')
      let newArr = []
      arr.forEach(item => {
        newArr.push({ url: item })
      })
      return newArr
    },
    calcEditData() {
      let { repairPlanData, videoData, wareList, authData, courseClassificationVOList, welfareId, viewCourse, viewTemplate } = this.form;
      //课程分类
      let categArr = []
      courseClassificationVOList && courseClassificationVOList.forEach(itt => {
        let arr = [itt.id]
        if (itt.courseClassificationVO) {
          arr.push(itt.courseClassificationVO.id)
          if (itt.courseClassificationVO.courseClassificationVO) {
            arr.push(itt.courseClassificationVO.courseClassificationVO.id)
          }
        }
        categArr.push(arr)
      })
      this.$set(this.form, 'courseClassificationList', categArr);
      // if (this.sourceType === 1) this.$set(this.form, 'welfareId', welfareId );
      this.$set(this.form, 'authData', [{ authType: 1 }, { authType: 2 }, { authType: 3 }]);
      // 处理APP展示数据：根据viewCourse和viewTemplate初始化appDisplay数组
      let appDisplayArr = []
      if (viewCourse === 1) {
        appDisplayArr.push(1) // 课程
      }
      if (viewTemplate === 1) {
        appDisplayArr.push(2) // 业务物料
      }
      this.$set(this.form, 'appDisplay', appDisplayArr.length > 0 ? appDisplayArr : []);
      //课件
      // this.$set(this.form, 'wareList', this.clacArrObj(wareList));
      // //上传课程
      // if (videoData) {
      //   let list = JSON.parse(videoData)
      //   list.forEach(it => {
      //     it.videoUrl = [{ url: it }]
      //   })
      //   this.$set(this.form, 'videoData', list);
      // } else {
      //   this.$set(this.form, 'videoData', [{ chaptersNum: '', name: '', coverImage: '', videoUrl: [] }]);
      // }
      // //修复方案
      // if (repairPlanData) {
      //   this.$set(this.form, 'repairPlanData', JSON.parse(repairPlanData));
      // } else {
      //   this.$set(this.form, 'repairPlanData', [{ name: '', coverImage: '', introduce: '', contentDetails: '' }]);
      // }
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      if (!params.id) {
        //处理上传课程
        if (params.type === 1) delete params.videoData
        if (params.type === 2) {
          params.chapterNum = params.videoData ? params.videoData.length : 0
          params.videoData.forEach(it => {
            if (!it.coverImage) it.coverImage = params.videoData[0].coverImage
            it.videoUrl = it.videoUrl.map(video => video.url).toString()
          })
          params.videoData = JSON.stringify(params.videoData)
          params.repairPlanData.forEach(item => item.contentDetails = encodeURIComponent(item.contentDetails))
          params.repairPlanData = JSON.stringify(params.repairPlanData)
        }
      }
      //处理学习权限
      if (this.sourceType === 2) {
        let arr = [], authList = params.authData;
        for (let i = 0; i < authList.length; i++) {
          let customerLevelIds = authList[i].customerLevel.filter(itt => itt.isActive).map(item => item.key)
          let technicalServiceLevelIds = authList[i].technicalServiceLevel.filter(itt => itt.isActive).map(item => item.key)
          let registerRoleIds = authList[i].registerRole.filter(itt => itt.isActive).map(item => item.key)
          let insideStaffIds = authList[i].insideStaff.filter(itt => itt.isActive).map(item => item.key)
          if (customerLevelIds.length > 0) arr.push({ authType: authList[i].authType, levelSource: 1, levelIds: customerLevelIds.toString() })
          if (technicalServiceLevelIds.length > 0) arr.push({ authType: authList[i].authType, levelSource: 2, levelIds: technicalServiceLevelIds.toString() })
          if (registerRoleIds.length > 0) arr.push({ authType: authList[i].authType, levelSource: 3, levelIds: registerRoleIds.toString() })
          if (insideStaffIds.length > 0) arr.push({ authType: authList[i].authType, levelSource: 4, levelIds: insideStaffIds.toString() })
        }
        params.authData = arr
      }
      // 处理APP展示参数
      if (params.appDisplay && Array.isArray(params.appDisplay)) {
        // 如果包含1（课程），设置viewCourse = 1
        if (params.appDisplay.includes(1)) {
          params.viewCourse = 1
        } else {
          params.viewCourse = 0
        }
        // 如果包含2（业务物料），设置viewTemplate = 1
        if (params.appDisplay.includes(2)) {
          params.viewTemplate = 1
        } else {
          params.viewTemplate = 0
        }
      } else {
        params.viewCourse = 0
        params.viewTemplate = 0
      }
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid, invalidFields) => {
        if (!valid) console.log(invalidFields)
        if (valid) {
          if (this.sourceType === 2 && !this.nextStep && !this.form.id) return this.nextStep = 1
          let params = this.calcParams()
          if (this.sourceType === 2 && !params.id) {
            let studyAuth = params.authData.find(it => it.authType === 1)
            if (!studyAuth) return this.$message.error('请选择免费学习权限')

          }
          if (this.sourceType === 1) {
            params.authData = ''
            params.isExam = 0
            params.creditRewards = 0
          }
          if (this.sourceType === 2) {
            params.welfareId = 0
            params.authData = JSON.stringify(params.authData)
          } else {
            params.welfareId = params.welfareId
          }
          if (params.type === 1) {
            params.repairPlanData = ''
            params.videoData = ''
            params.lecturerId = 0
          }
          if (this.sourceType === 2) params.courseClassificationList = params.courseClassificationList.map(subArray => subArray.at(-1));
          if (params.type === 2 && !params.id) params.wareList = params.wareList && params.wareList.length ? params.wareList.map(banner => banner.url) : []
          params.orderNo = +params.orderNo
          this.submitGoods(params)
        }
      });
    },
    submitGoods(params) {
      delete params.studyAuth
      if (params.id) {
        delete params.freeLearningAuth
        delete params.lookCreditAuth
        delete params.paidLearningAuth
        delete params.courseClassificationVOList
        delete params.courseSubjectRepairPlanList
        delete params.courseSubjectVideoList
        delete params.courseSubjectWaresList
      }
      params.collectNum = +params.collectNum || 0
      params.examDuration = +params.examDuration || 0
      params.examNum = +params.examNum || 0
      params.examOrder = +params.examOrder || 0
      params.forwardNum = +params.forwardNum || 0
      params.likeNum = +params.likeNum || 0
      params.playNum = +params.playNum || 0
      params.examRules = +params.examRules || 0
      if (params.id > 0) {
        courseSubjectApi.update(params).then((data) => {
          this.postCallback(data)
        });
      } else {
        courseSubjectApi.create(params).then((data) => {
          this.postCallback(data)
        });
      }
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
